export default __webpack_public_path__ + "media/images/mailer-new/welcome/purple-extra-soft-wave-378e5d797a4b2909509e409a82c58d70.png";